<template>
  <settings-modal class="payment-swift-topup-cancel-duplicate-modal t-payment-swift-topup-cancel-duplicate-modal">
    <template slot="heading">{{ heading }}</template>

    <error-alert :error="error" />

    <p
      class="subheading red--text text-darken-2 mb-0"
    >Before you confirm, make sure that payment is duplicate.</p>

    <template slot="actions">
      <v-btn
        id="cancel-duplicate"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  import form from '@/mixins/form'

  export default {
    name: 'PaymentSwiftTopUpCancelDuplicateModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        paymentCancelSettleSwiftTopUpDuplicateByAccountant: new ApiRequest(PaymentApi.cancelSettleSwiftTopUpDuplicateByAccountant)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      payment () {
        return this.modal.data.payment
      },
      heading () {
        return `Cancel duplicate payment ${this.payment.id}?`
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.paymentCancelSettleSwiftTopUpDuplicateByAccountant
          .execute(this.payment.id)
          .then(this.cancelSuccessHandler)
          .catch(this.cancelErrorHandler)
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      cancelSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Payment has been successfully cancelled and settled.' }
          })
        }, 100)
      },
      cancelErrorHandler () {
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'ErrorFlashModal',
            data: { message: 'Payment has not been cancelled and settled.' }
          })
        }, 100)
      }
    }
  }
</script>

<style lang="scss">
  .payment-swift-topup-cancel-duplicate-modal {
    &.settings-modal {
      .container {
        padding-bottom: 28px;
      }
    }
  }
</style>
